// extracted by mini-css-extract-plugin
export var activeDot = "_48-c";
export var buttonContainer = "_48-9";
export var channelButton = "_48-a";
export var clickable = "_48-d";
export var content = "_48-0";
export var contentFull = "_48-2";
export var contentThird = "_48-1";
export var contentWrapper = "_48-7";
export var description = "_48-5";
export var heightShort = "_48-f";
export var image = "_48-3";
export var imageContainer = "_48-4";
export var selectButton = "_48-e";
export var spinnerContainer = "_48-b";
export var titleContent = "_48-8";
export var titleWrapper = "_48-6";